import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {SanitizationService} from '../sanitization.service';
import {UiConfigService} from '@lv1871/core';
import {UiControl} from '../../models/uiControl';
import {Observable} from 'rxjs';

export interface CommandRequest {
  uiControl: UiControl;
  clientUrl: string;
}

export interface CommandResponse {
  uiControl: UiControl;
  redirectUrl: string;
}

@Injectable({
  providedIn: 'root'
})
export class ProcessRestService {

  constructor(private _http: HttpClient, private _uiConfigService: UiConfigService, private _sanitizer: SanitizationService) {
  }

  public postCommand(commandName: string, processId: string, request: CommandRequest): Observable<CommandResponse> {
    const url = this._uiConfigService.getAntragserfassungUrl() + '/api/process/' + commandName + '?processId=' + processId;
    const body = {
      uiControl: this._sanitizer.sanitize(request.uiControl),
      clientUrl: request.clientUrl
    } as CommandRequest;
    return this._http.post<CommandResponse>(url, body);
  }
}
